<obg-feature-unavailable-container
	[titleText]="'not-found.title'"
	[caption]="'not-found.description'"
	[statusCode]="statusCode"
>
	<img class="not-found-image" obgImageContent="not-found.error-image" />
</obg-feature-unavailable-container>
